module.exports = __webpack_public_path__ + "static/media/hadriankanal.0f726ea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/hadriankanal.png
// module id = 677
// module chunks = 0